export default __webpack_public_path__ + "static/media/head04_vi_pc.6b53ea78.png";